// extracted by mini-css-extract-plugin
export default {"imageStripContainer":"SZbfohOTr8V5YZwE4GOB"};